import { getDeviceType } from '@picsart/design-system/utils/device';

export const isDesktop = getDeviceType() === 'desktop';
export const isTablet = getDeviceType() === 'tablet';
export const isMobile = getDeviceType() === 'mobile';
